import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { Order } from 'gung-standard';
import { map, Observable } from 'rxjs';
import { JeevesOpenOrderTableComponent } from '../../components/jeeves-open-order-table/jeeves-open-order-table.component';
import { JeevesOrderListConfigService } from '../jeeves-order-list-config/jeeves-order-list-config.service';

@Injectable({
  providedIn: 'root'
})
export class JeevesQuotesListConfigService extends JeevesOrderListConfigService {
  getItems(): Observable<Order[]> {
    return super.getItems().pipe(map(orders => orders.filter((order: Order) => order.extra.oh.ordstat === 0)));
  }

  getFilters(): ConfigBaseFilter<Order>[] {
    return [];
  }

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => JeevesOpenOrderTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Product grid'
      }
    ];
  }
}
